//TODO - Refatorar para a tela inteira e tirar componentes sendo chamados em forma de função

import React, { useState, useEffect } from "react";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import Link from "@material-ui/core/Link";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
import IconButton from "@material-ui/core/IconButton";
import Grid from "@material-ui/core/Grid";
import {
    ControlCameraSharp,
    Visibility,
    VisibilityOff
} from "@material-ui/icons";
import { useForm } from "react-hook-form";
import { Redirect, useHistory } from "react-router-dom";
import api from "../../services/api";
import { useDispatch } from "react-redux";
import CircularProgress from "@material-ui/core/CircularProgress";
import { MxAlertaActions } from "../../store/ducks/components/mxalerta/mxalerta";
import { LoginActions } from "../../store/ducks/application/login/login";
import useStyles from "./style.js";
import mxStyles from "../../styles/MxStyle";
import clsx from "clsx";
import { MxUtils } from "../../utils/mxutils";
import { useMutation, useQueryClient } from "react-query";
import { fetchAplicativos } from "../../utils/fetchFunctions";
import { persistor, store } from "../../store/index";
import { LinearProgress, linearProgressClasses, styled } from "@mui/material";

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
    },
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 5,
        backgroundColor: theme.palette.mode === 'light' ? '#1a90ff' : '#308fe8',
    },
}));

const Login = () => {
    const dispatch = useDispatch();
    const classes = useStyles();
    const mx_Style = mxStyles();
    const history = useHistory();

    const { register, handleSubmit } = useForm();
    const [showPassword, setShowPassword] = useState(false);
    const prefetchAplicativosMarimex = usePrefechAplicativos();
    const logar = useMutationLogar({});

    const [usage, setUsage] = useState(0);
    const [quota, setQuota] = useState(0);

    useEffect(() => {
        async function getStorageInfo() {
            if (navigator.storage && navigator.storage.estimate) {
                const estimate = await navigator.storage.estimate();

                setUsage(estimate.usage || 0);
                setQuota(estimate.quota || 0);
            }
        }

        const conn =
            navigator.connection ||
            navigator.mozConnection ||
            navigator.webkitConnection;

        store.dispatch(LoginActions.ConnectionType(`${conn.type}`));

        getStorageInfo();
    }, []);


    /**
     * @typedef {Object} Params
     * @property {() => void} [onConfirmar]
     * @property {() => void} [onRecusar]
     * @param {Params} params
     */
    function confirmarGoToAlterarSenha({
        onConfirmar = () => { },
        onRecusar = () => { }
    }) {
        dispatch(
            MxAlertaActions.ExecutarConfirm(
                " Validade senha",
                `Sua senha irá expirar em ${Math.round(
                    MxUtils.getHorasParaExpirarSenhaUsuario() / 24
                )} dia(s), deseja alterá-la agora?`,
                () => {
                    history.push("/alterarsenha");
                    onConfirmar();
                },
                () => {
                    onRecusar();
                }
            )
        );
    }

    /**
     * @param {{data: Login}} loginData
     * @param {{Login: string, Senha: string}} data
     */
    async function onLoginSuccess(loginData, data) {
        // * Necessário resetar o estado do redux para certificar que não haverá conflitos com o estado anterior depois de uma atualização
        dispatch({ type: "ROOT/RESET" });
        dispatch(LoginActions.Logar({ ...loginData.data, Login: data.Login }));
        await persistor.flush();
        MxUtils.clearStateAppMinimize("*");
        prefetchAplicativosMarimex();
    }

    /**
     * @param {{Login: string, Senha: string}} data
     * @param {React.BaseSyntheticEvent<object, any, any>} [e]
     */
    function handleLogar(data, e) {
        if (!e) return;
        e.preventDefault();
        logar.mutate(data, {
            onSuccess: async loginData => {
                await onLoginSuccess(loginData, data);
                let horasParaExpirarSenhaUsuario =
                    MxUtils.getHorasParaExpirarSenhaUsuario();
                if (horasParaExpirarSenhaUsuario < 24) {
                    history.push("/alterarsenha");
                    return;
                }
                if (horasParaExpirarSenhaUsuario < 240) {
                    confirmarGoToAlterarSenha({
                        onRecusar: () => {
                            history.push("/escolhaterminal");
                        }
                    });
                    return;
                }

                history.push("/escolhaterminal");
            }
        });
    }

    // function pushAlterarSenha() {
    //     history.push("/alterarsenha");
    // }

    // function pushEscolhaTerminal() {
    //     history.push("/escolhaterminal");
    // }

    useEffect(() => {
        // * Efeito que checa se o usuário já está logado e esse login é valido (senha não expirou)
        if (!MxUtils.getToken()) return;
        if (MxUtils.getDataAtual() > MxUtils.getDataExpiracaoToken()) {
            dispatch(
                MxAlertaActions.Executar(
                    "Sessão expirada, faça o login novamente.",
                    "error"
                )
            );
            MxUtils.limparStorageLogin();

            // ? Existe um login mas a senha está próxima de expirar
        } else if (MxUtils.getHorasParaExpirarSenhaUsuario() < 240) {
            // ? A senha está a menos de 24 horas de expirar, então redireciona para a tela de alterar senha
            if (MxUtils.getHorasParaExpirarSenhaUsuario() < 24)
                history.push("/alterarsenha");
            // ? Do contrário, pergunta se o usuário deseja alterar a senha
            else
                confirmarGoToAlterarSenha({
                    onRecusar: () => history.push("/ListagemAplicativos")
                });

            // ? Existe um login e a senha não está próxima de expirar, redireciona para a tela de escolha de listagem de app
        } else {
            history.push("/ListagemAplicativos");
        }
    }, []);

    const formatBytes = (bytes) => {
        if (!bytes) return "0 B";
        const sizes = ["B", "KB", "MB", "GB"];
        const i = Math.floor(Math.log(bytes) / Math.log(1024));
        return (bytes / Math.pow(1024, i)).toFixed(2) + " " + sizes[i];
    };

    return (
        <Container component="main" maxWidth="xs">
            <CssBaseline />
            <Grid
                style={{
                    position: 'absolute',
                    right: 0,
                    margin: 15
                }}
            >
                {/* <div>
                    <p>Usado: {formatBytes(usage)}</p>
                    <p>Total disponível: {formatBytes(quota)}</p>
                    <p>Livre: {formatBytes(quota - usage)}</p>
                </div> */}
                <Grid
                    container
                >
                    <Grid
                        item
                        xs={12}
                        style={{
                            textAlign: 'center'
                        }}
                    >
                        <BorderLinearProgress variant="determinate" value={((quota * 100) / usage)} />
                        {formatBytes(usage)} / {formatBytes(quota)}
                    </Grid>
                </Grid>
                <p>Connection Type: {store.getState().loginreducer.ConnectionType}</p>
            </Grid>
            <div className={classes.paper}>
                <div
                    className={clsx(classes.animatedItem, {
                        [classes.animatedItemExiting]: false
                    })}
                >
                    <Grid
                        style={{
                            justifyContent: "center",
                            alignItems: "center"
                        }}
                    >
                        <Box>
                            <Avatar
                                className={classes.avatar}
                                alt="Remy Sharp"
                                src={`/logo.png`}
                            />
                        </Box>
                    </Grid>

                    <Box
                        mt={2}
                        textAlign="center"
                        component={"h1"}
                        style={{
                            marginBlock: "16px 0",
                            display: "flex",
                            flexDirection: "column",
                            gap: 4
                        }}
                    >
                        <span
                            style={{
                                fontSize: 22,
                                fontWeight: "bold",
                                color: "#005aab"
                            }}
                        >
                            Marimex
                        </span>

                        <span
                            style={{
                                fontSize: 14,
                                fontWeight: "500",
                                color: "#005aab"
                            }}
                        >
                            Inteligência Portuária em Logística Integrada
                        </span>
                    </Box>
                </div>

                {/* <Box mt={2} textAlign="center">
            <span style={{ fontSize: 22, fontWeight: 'bold', color: "#3f51b5" }}>
              <Flip top cascade>Marimex</Flip>
            </span>
            <span style={{ fontSize: 14, fontWeight: '500', color: "#3f51b5" }}>
              <Flip top cascade>Inteligência Portuária em Logística Integrada</Flip>
            </span>
          </Box> */}

                <form noValidate={false} onSubmit={handleSubmit(handleLogar)}>
                    <Box mt={3}></Box>

                    <TextField
                        inputRef={register({ required: true })}
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        id="Login"
                        label="Usuário ou CPF"
                        name="Login"
                        autoComplete="email"
                    />
                    <TextField
                        inputRef={register}
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        name="Senha"
                        label="Senha"
                        id="Password"
                        type={showPassword ? "text" : "password"}
                        autoComplete="current-password"
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton
                                        size="small"
                                        aria-label="Toggle password visibility"
                                        onClick={() =>
                                            showPassword
                                                ? setShowPassword(false)
                                                : setShowPassword(true)
                                        }
                                    >
                                        {showPassword ? (
                                            <Visibility />
                                        ) : (
                                            <VisibilityOff />
                                        )}
                                    </IconButton>
                                </InputAdornment>
                            )
                        }}
                    />
                    <Box
                        mt={3}
                        style={{
                            marginTop: 16,
                            display: "flex",
                            flexDirection: "column",
                            gap: 24
                        }}
                    >
                        <ButtonSubmit carregando={logar.isLoading} />
                        {!(MxUtils.validarAmbienteProducao() ?? true) ? (
                            <AvisoAmbiente />
                        ) : (
                            <></>
                        )}
                        <div className={mx_Style.spinner}>
                            <SpinnerCarregando carregando={logar.isLoading} />
                        </div>
                    </Box>
                </form>
            </div>

            <Box mt={8}>
                <Copyright />
                <AvisoVersao />
            </Box>
        </Container>
    );
};

function Copyright() {
    return (
        <Typography variant="body2" color="textSecondary" align="center">
            {"Copyright © "}
            <Link color="inherit" href="https://www.marimex.com.br/">
                Marimex
            </Link>{" "}
            {new Date().getFullYear()}
            {""}
        </Typography>
    );
}

function AvisoAmbiente() {
    return (
        <div
            style={{
                backgroundColor: "green",
                border: 5,
                borderRadius: 5,
                display: "flex",
                justifyContent: "center"
            }}
        >
            <Typography
                component={"span"}
                variant="h6"
                style={{ color: "#FFFFFF", justifySelf: "center" }}
                align="center"
            >
                *** Ambiente de Homologação ***
            </Typography>
        </div>
    );
}

export function AvisoVersao({ showIndexedDBInfo }) {
    const formatBytes = (bytes) => {
        if (!bytes) return "0 B";
        const sizes = ["B", "KB", "MB", "GB"];
        const i = Math.floor(Math.log(bytes) / Math.log(1024));
        return (bytes / Math.pow(1024, i)).toFixed(2) + " " + sizes[i];
    };

    const [usage, setUsage] = useState(0);
    const [quota, setQuota] = useState(0);

    useEffect(() => {
        async function getStorageInfo() {
            if (navigator.storage && navigator.storage.estimate) {
                const estimate = await navigator.storage.estimate();

                setUsage(estimate.usage || 0);
                setQuota(estimate.quota || 0);
            }
        }

        const conn =
            navigator.connection ||
            navigator.mozConnection ||
            navigator.webkitConnection;

        store.dispatch(LoginActions.ConnectionType(`${conn.type}`));

        getStorageInfo();
    }, []);

    return (
        <>
            <Typography variant="body2" color="textSecondary" align="center">
                {"Versão 1.0.0.89"}
            </Typography>
            {
                showIndexedDBInfo ?
                    <>
                        <div>
                            <p>Usado: {formatBytes(usage)}</p>
                            <p>Total disponível: {formatBytes(quota)}</p>
                            <p>Livre: {formatBytes(quota - usage)}</p>
                        </div>
                        <BorderLinearProgress variant="determinate" value={((quota * 100) / usage)} />
                    </>
                    : null
            }
        </>
    );
}

function SpinnerCarregando({ carregando }) {
    return carregando ? <CircularProgress /> : <></>;
}
function ButtonSubmit({ carregando }) {
    if (carregando) {
        return (
            <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                disabled
            >
                OK
            </Button>
        );
    } else {
        return (
            <Button type="submit" fullWidth variant="contained" color="primary">
                OK
            </Button>
        );
    }
}

export default Login;

function usePrefechAplicativos() {
    const queryClient = useQueryClient();
    return () => {
        queryClient.prefetchQuery(["Global", "Aplicativos"], fetchAplicativos);
    };
}
/**
 * @typedef {Object} Login
 * @property {string} Login
 * @property {string} Senha
 *
 * @typedef {Object} LoginResponse
 *
 */
/**
 * @type {import("react-query").MutationFunction<any, Login>}
 */
async function mutateLogar(Login) {
    return await api.post(
        "/MarimexAuthentication/api/usuario/autenticar",
        Login
    );
}

/**

 * @param {import("../../@types").ParseMutateOptions<typeof mutateLogar>} options 
 */
function useMutationLogar(options = {}) {
    return useMutation(mutateLogar, {
        onError: error => {
            console.error(error, error.response);
            MxUtils.alertaErro(
                "Ocorreu um erro ao consultar os dados do usuário: " +
                error.response?.data?.Message || error.message
            );
        },
        ...options
    });
}
